module.exports = __webpack_public_path__ + "img/9-9.50075248.png";